import React from 'react';
import { AutoSizer, List, ListRowRenderer } from 'react-virtualized';
import { ListGroupItem } from 'reactstrap';
import downloadFile from '../utils/downloadFile';

const getFileExtension = (url: string): string => {
  const splitUrl = url.split('.');
  return splitUrl.length > 0 ? splitUrl[splitUrl.length - 1] : '';
};

export type IDownloadFiles = {
  data: [
    {
      url: string;
      description: string;
    }
  ];
};

const DownloadFiles: React.FC<IDownloadFiles> = ({ data }) => {
  const renderUrlList: ListRowRenderer = ({ index, key, style }) => {
    const row = data[index];

    return (
      <ListGroupItem
        onClick={event => {
          event.preventDefault();
          downloadFile(row.url, `${row.description}.${getFileExtension(row.url)}`);
        }}
        key={key}
        style={style}
        className="mp3-list-item"
      >
        <span>
          <strong>{`${index + 1}. `}</strong>
          {row.description}
        </span>
        <span>{getFileExtension(row.url)}</span>
      </ListGroupItem>
    );
  };

  return (
    <div className="mp3-download">
      <AutoSizer>
        {({ height, width }) => (
          <List height={height} width={width} rowCount={data.length} rowHeight={40} rowRenderer={renderUrlList} />
        )}
      </AutoSizer>
    </div>
  );
};

export default DownloadFiles;
